import {
    Button,
    CircularProgress,
    Grid,
    Paper,
    Table,
    TableBody,
    TableContainer,
    TableRow,
} from "@mui/material";
import { useState } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import { useProductsByIds } from "../../../services/productsService";
import { StyledTableCell, StyledTableHead } from "../../table/BaseTable/BaseTable";
import { IncreaseDiscountRequestDialog } from "./IncreaseDiscountRequestDialog";
import { SendProposalDialog } from "../../../page/SalesProductsPage/SendProposalDialog/SendProposalDialog";
import { ProductRow } from "./ProductRow";
import {DiscountSummaryRow} from "./DiscountSummaryRow"

export const DiscountFormControl = (props) => {
    const { fields, readonly, showIncreaseRequestButton = true } = props;
    const { t } = useTranslation();

    const [isGross, setIsGross] = useState(true);

    const discounts = useWatch({ name: fields.discount });
    const productIds = Object.keys(discounts);

    const { isLoading, data: products } = useProductsByIds(productIds);

    const { openDialog } = useDialogBetter();
    const openIncreaseDiscountRequestDialog = () => {
        openDialog({
            Component: SendProposalDialog,
            componentProps: {
                productIds: productIds,
                disabledStatusProposal: true,
            },
        });
    };

    if (isLoading || !products) {
        return <CircularProgress />;
    }

    return (
        <Grid container direction="column">
            <Grid item container direction="row" justifyContent="space-between">
                <Grid item container direction="row" sx={{ width: "auto" }}>
                    <Grid item>
                        <Button
                            onClick={() => setIsGross(true)}
                            variant={isGross ? "contained" : "outlined"}
                            sx={{
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                borderTopRightRadius: 0,
                                marginRight: 0,
                            }}
                        >
                            {t("DiscountFormControl.gross")}
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button
                            onClick={() => setIsGross(false)}
                            variant={!isGross ? "contained" : "outlined"}
                            sx={{
                                borderBottomLeftRadius: 0,
                                borderBottomRightRadius: 0,
                                borderTopLeftRadius: 0,
                            }}
                        >
                            {t("DiscountFormControl.net")}
                        </Button>
                    </Grid>
                </Grid>
                {showIncreaseRequestButton && (
                    <Grid item>
                        <Button disabled={false} onClick={openIncreaseDiscountRequestDialog}>
                            {t("DiscountFormControl.requestDiscountIncrease")}
                        </Button>
                    </Grid>
                )}
            </Grid>
            <Grid item>
                <TableContainer
                    component={Paper}
                    sx={{
                        borderTopLeftRadius: 0,
                    }}
                >
                    <Table>
                        <StyledTableHead>
                            <TableRow>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.number")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.productType")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.vat")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.footage")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.maxDiscount")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.offerPrice")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.offerPricePerSqm")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.minSalePrice")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.minSalePricePerSqm")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.discountPercent")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.discountAmount")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {t("DiscountFormControl.table.discountAmountPerSqm")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {isGross ? t("DiscountFormControl.table.totalPrice") : t("DiscountFormControl.table.totalPriceNet")}
                                </StyledTableCell>
                                <StyledTableCell>
                                    {isGross ? t("DiscountFormControl.table.totalPricePerM2") : t("DiscountFormControl.table.totalPriceNetPerM2")}
                                </StyledTableCell>
                            </TableRow>
                        </StyledTableHead>
                        <TableBody>
                            {products.map((product) => (
                                <ProductRow
                                    key={product.id}
                                    product={product}
                                    fields={fields}
                                    gross={isGross}
                                    readonly={readonly}
                                />
                            ))}
                            <DiscountSummaryRow products={products} fields={fields} gross={isGross}/>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Grid>
        </Grid>
    );
};
